
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import React, { useEffect, useRef, useState } from 'react';
import { Api } from '../../services/api';
import classNames from 'classnames';
import { format, parse } from 'date-fns';
import { addLocale, locale } from 'primereact/api';
import { FaFileExcel, FaSearch, FaTimes } from 'react-icons/fa';
import { mask } from 'remask';
import { CalendarPague } from '../../styles/primeReactConfig';
import GeraXLSX from '../../utils/GeraXLSX';

export default function TransfersTable() {
  const calendarInit = useRef(null)
  const calendarEnd = useRef(null)

  const headers = ['Codigo do Cliente', 'Documento', 'Nome', 'Descrição', 'Valor', 'Forma de Pagamento', 'Situacao']
  const fields =
    [
      'codigo_cliente',
      'documento_cliente',
      'nome_cliente',
      'cobranca_descricao',
      'valor_original',
      'formapagamento',
      'situacao',
    ]

  let ignore = false
  const data_dt = useRef()
  const plataforma = useRef(null)
  const deposito_id = useRef(null)
  const loadTransations = useRef(false)
  const [loading, setLoading] = useState(true);
  const [loadingDialog, setLoadingDialog] = useState(true);
  const [first, setFirst] = useState(0);
  const [transationData, setTransationData] = useState([]);
  const [infoTransation, setInfoTransation] = useState([]);
  const [showTransationInfo, setShowTransationInfo] = useState(false);
  const [totalTransation, setTotalTransation] = useState(0);
  const [dateDialog, setDateDialog] = useState('00/00/0000')
  const [rows, setRows] = useState(5);
  const [rowsPerPageOptions] = useState([5, 10]);
  const [loadingCSV, setLoadingCSV] = useState(false)
  const [initDate, setInitDate] = useState();
  const [endDate, setEndDate] = useState();
  const [searchState, setSearchState] = useState(false);
  const [dataSelecionada, setDataSelecionada] = useState('');

  addLocale('pt-BR', {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Claro'
  });
  locale('pt-BR');

  const today = new Date();

  useEffect(() => {
    getAll()
  }, []);

  const getAll = async (e = 0, rows = 10) => {
    setLoading(true);
    try {
      const { data } = await Api.get(`/historicodeposito/${rows}/${e}`);
      setTransationData(data.rows);
      setTotalTransation(data.count);
    } catch (error) {
      console.log(error.response);
    }
    finally {
      setLoading(false);
    }
  }

  const Search = async (e = 0, rows = 10) => {
    setLoading(true)
    try {
      const { data } = await Api.get(`/historicodeposito/${format(initDate, 'yyyy-MM-dd')}/${format(endDate, 'yyyy-MM-dd')}/${rows}/${e}`)
      setTransationData(data.rows)
      setTotalTransation(data.count)
    } catch (error) {
      console.log(error.response)
    }
    finally {
      setLoading(false)
    }
  }

  const generateXLSX = () => {
    setLoadingCSV(true)
    const parametrosXLSX = {
      data: formataCampos(infoTransation),
      headers: headers,
      fields: fields,
      titulo: `Transações_dia_${format(parse(dateDialog, 'dd/MM/yyyy', new Date()), 'dd-MM-yyyy')}`
    }
    GeraXLSX(parametrosXLSX)
    setLoadingCSV(false)
  }

  const formataCampos = (array) => {
    const arrayFormatado = []
    array.forEach((item) => {
      arrayFormatado.push({
        codigo_cliente: item.codigo_cliente,
        documento_cliente: mask(item.documento_cliente, ['999.999.999-99', '99.999.999/9999-99']),
        nome_cliente: item.nome_cliente,
        cobranca_descricao: item.cobranca_descricao,
        valor_original: Number(item.valor_original),
        formapagamento: item.formapagamento,
        situacao: item.situacao,
      })
    })
    return arrayFormatado
  }

  function onPage(event) {
    const startIndex = parseInt(event.first);
    setRows(event.rows)
    setFirst(startIndex);
    if (searchState) {
      return Search(event.page, event.rows);
    }
    return getAll(event.page, event.rows);
  }

  function Show(rowData) {
    setShowTransationInfo(true);
    data_dt.current = rowData.data_dt
    plataforma.current = rowData.plataforma_pagamento_id
    deposito_id.current = rowData.hdn_id
    loadTransations.current = !loadTransations.current;
    setDataSelecionada(rowData.data_dt);
    setDateDialog(rowData.data);

    const getTransationInfo = async () => {
      setLoadingDialog(true)
      try {
        const { data } = await Api.get(`historicotransacoes/deposito?date=${data_dt.current}&plataforma=${plataforma.current}&deposito_id=${deposito_id.current}`);
        if (!ignore) {
          setInfoTransation(data);
          setLoadingDialog(false);
        }
      } catch (error) {
        console.log(error.response)
        setLoadingDialog(false);
      }
    }

    getTransationInfo()
  }


  const formatCurrency = (value) => {
    if (value) {
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
    return "Carregando..."
  };

  const transationTableHeader = (
    <div className="items-center grid w-full">
      <div className='flex flex-wrap justify-center w-full gap-2'>
        <p className='w-full text-lg'>Buscar por período</p>
        <div className='flex flex-row gap-2'>
          <Calendar
            value={initDate}
            maxDate={today}
            locale="pt-BR"
            dateFormat="dd/mm/yy"
            onChange={(e) => {
              //calendarInit.current.hideOverlay()
              setInitDate(e.value)
            }}
            pt={CalendarPague}
            yearNavigator
            placeholder="ex: 25/05/2019"
            yearRange="2020:2030"
            id="vencimento"
            required
            mask="99/99/9999"
            ref={calendarInit}
          />
          <Calendar
            value={endDate}
            minDate={initDate}
            locale="pt-BR"
            dateFormat="dd/mm/yy"
            onChange={(e) => {
              //calendarEnd.current.hideOverlay()
              setEndDate(e.value)
            }}
            pt={CalendarPague}
            yearNavigator
            placeholder="ex: 25/05/2019"
            yearRange="2020:2030"
            id="vencimento"
            required
            mask="99/99/9999"
            ref={calendarEnd}
          />
        </div>
        <div className='flex flex-row gap-2'>
          <Button
            type="button"
            icon={<FaSearch className='text-xl' />}
            pt={{
              root: `bg-green-500 hover:bg-green-600 border-0
                dark:bg-green-400 dark:hover:bg-green-500
                flex justify-center items-center
                h-[3rem] w-[3rem] p-0
                rounded-lg text-white dark:text-black`,
              label: "absolute"
            }}
            onClick={() => { Search(); setSearchState(true) }}
          />
          <Button
            type="button"
            icon={<FaTimes className='text-2xl' />}
            pt={{
              root: `bg-red-500 hover:bg-red-600 border-0
                dark:bg-red-400 dark:hover:bg-red-500
                flex justify-center items-center
                h-[3rem] w-[3rem] p-0
                rounded-lg text-white dark:text-black`,
              label: "absolute"
            }}
            onClick={() => { getAll(); setSearchState(false); setInitDate(); setEndDate() }}
          />
        </div>
      </div>
    </div>
  );

  const actionTemplate = (rowData) => {
    return (
      <div>
        <Button
          type="button"
          icon={<FaSearch />}
          pt={{
            root: `hover:dark:bg-sky-300 hover:bg-sky-950 
            dark:bg-sky-400 bg-sky-900 p-3 rounded-full
            text-white dark:text-black`,
            label: 'absolute'
          }}
          onClick={() => Show(rowData)}>
        </Button>
      </div>
    )
  }

  const transationHeader = (
    <div className='flex justify-between px-2 w-full'>
      <div className='text-2xl'>
        <h4>Detalhes da transação do dia {dateDialog}</h4>
      </div>
      {/* <div className=" mt-4 md:mt-0 md:ml-0">
        <Button
          type="button"
          icon={<FaFileExcel className='text-3xl text-white dark:text-black' />}
          ptOptions={{
            mergeSections: false
          }}
          pt={{
            root: `hover:dark:bg-emerald-300 hover:bg-green-600 
            dark:bg-emerald-400 bg-green-500 p-3 rounded-lg
            text-white dark:text-black`,
            label: "absolute"
          }}
          onClick={() => generateXLSX()}
          loading={loadingCSV}
          tooltip="Baixar como CSV"
          tooltipOptions={{ position: "bottom" }}
        >
        </Button>
      </div> */}
    </div>
  )



  return (
    <>
      <Dialog
        onHide={() => { setShowTransationInfo(false); setInfoTransation([]) }}
        visible={showTransationInfo}
        draggable
        pt={{
          root: 'max-w-screen md:max-w-[80vw]',
          header: classNames('flex items-center justify-between shrink-0',
            'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
            'dark:bg-gray-900  dark:text-white/80'),
          content: ({ state }) => ({
            className: classNames('overflow-auto w-full max-h-[80vh]',
              'bg-white text-gray-700 px-6 pb-8 pt-0',
              'rounded-bl-lg rounded-br-lg',
              'dark:bg-gray-900 dark:text-white/80 ', {
              "grow": state.maximized
            })
          }),
        }}
        header={transationHeader}
      //className='w-[70vw]'
      >
        <Button
          type="button"
          icon={<FaFileExcel className='text-3xl text-white dark:text-black' />}
          ptOptions={{
            mergeSections: false
          }}
          pt={{
            root: `hover:dark:bg-emerald-300 hover:bg-green-600 
            dark:bg-emerald-400 bg-green-500 p-3 rounded-lg
            text-white dark:text-black mb-3`,
            label: "absolute",
          }}
          onClick={() => generateXLSX()}
          loading={loadingCSV}
          tooltip="Baixar como XLSX"
          tooltipOptions={{ position: "bottom" }}
        >
        </Button>
        <DataTable
          value={infoTransation}
          //header={transationHeader}
          scrollable
          //scrollHeight={'500px'}
          //pt={LargeTablePague}
          loading={loadingDialog}
        >
          <Column header="Código do Cliente" field="codigo_cliente" />
          <Column header="Documento" field="documento_cliente" body={rowData => mask(rowData.documento_cliente, ['999.999.999-99', '99.999.999/9999-99'])} />
          <Column header="Nome" field="nome_cliente" />
          <Column header="Descrição" field="cobranca_descricao" />
          <Column header="Valor" field="valor_original" body={rowData => formatCurrency(Number(rowData.valor_original))} />
          <Column header="Forma de Pagamento" field="formapagamento" />
          <Column header="Situação" field="situacao" />
          {/* {providerCartorio && <Column style={{ width: '5rem' }} header="Efetuar Baixa" body={rowData => baixaCartorio(rowData)} />} */}
        </DataTable>
      </Dialog>
      <div className="grid">
        <div className="w-full overflow-x-auto">
          <DataTable
            value={transationData}
            paginator
            rows={rows}
            rowsPerPageOptions={rowsPerPageOptions}
            totalRecords={totalTransation}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate='Exibindo {first} de {last} do total de {totalRecords}'
            first={first}
            scrollable
            lazy
            pt={{
              root: ({ props }) => ({
                className: classNames('relative', {
                  'flex flex-col h-full': props.scrollable && props.scrollHeight === 'flex'
                })
              }),
              loadingoverlay: {
                className: classNames(
                  'fixed w-full h-full t-0 l-0 bg-gray-100/40',
                  'transition duration-200',
                  'absolute flex items-center justify-center z-50',
                  'dark:bg-gray-950/40' // Dark Mode
                )
              },
              loadingicon: 'w-8 h-8',
              wrapper: ({ props }) => ({
                className: classNames({
                  relative: props.scrollable,
                  'flex flex-col grow h-full': props.scrollable && props.scrollHeight === 'flex'
                })
              }),
              header: ({ props }) => ({
                className: classNames(
                  'bg-transparent text-slate-700 border-none font-bold p-4',
                  'dark:border-none dark:text-white/80 dark:bg-transparent', // Dark Mode
                  props.showGridlines ? 'border-x border-t border-b-0' : 'border-y border-x-0'
                )
              }),
              table: 'w-full border-spacing-0',
              footer: {
                className: classNames(
                  'bg-slate-50 text-slate-700 border-t-0 border-b border-x-0 border-gray-300 font-bold p-4',
                  'dark:border-blue-900/40 dark:text-white/80 dark:bg-gray-900' // Dark Mode
                )
              },
              paginator: {
                firstpagebutton: ({ context }) => ({
                  className: classNames(
                    'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
                    'border-0 text-gray-500  min-w-[3rem] h-12 m-[0.143rem] rounded-md',
                    'hover:bg-slate-200 dark:hover:bg-sky-900',
                    'transition duration-200',
                    'dark:text-white', //Dark Mode
                    {
                      'cursor-default pointer-events-none opacity-60': context.disabled,
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
                    }
                  )
                }),
                previouspagebutton: ({ context }) => ({
                  className: classNames(
                    'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
                    'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
                    'hover:bg-slate-200 dark:hover:bg-sky-900',
                    'transition duration-200',
                    'dark:text-white', //Dark Mode
                    {
                      'cursor-default pointer-events-none opacity-60': context.disabled,
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
                    }
                  )
                }),
                nextpagebutton: ({ context }) => ({
                  className: classNames(
                    'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
                    'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
                    'hover:bg-slate-200 dark:hover:bg-sky-900',
                    'transition duration-200',
                    'dark:text-white', //Dark Mode
                    {
                      'cursor-default pointer-events-none opacity-60': context.disabled,
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
                    }
                  )
                }),
                lastpagebutton: ({ context }) => ({
                  className: classNames(
                    'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
                    'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
                    'hover:bg-slate-200 dark:hover:bg-sky-900',
                    'transition duration-200',
                    'dark:text-white', //Dark Mode
                    {
                      'cursor-default pointer-events-none opacity-60': context.disabled,
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]': !context.disabled // Focus
                    }
                  )
                }),
                pagebutton: ({ context }) => ({
                  className: classNames(
                    'relative inline-flex items-center justify-center user-none overflow-hidden leading-none',
                    'border-0 text-gray-500 min-w-[3rem] h-12 m-[0.143rem] rounded-md',
                    'transition duration-200 ',
                    'hover:bg-slate-200 dark:hover:bg-sky-900',
                    'dark:border-blue-300 dark:text-white', // Dark Mode
                    'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)]', // Focus
                    {
                      'font-bold bg-blue-50 border-blue-50 text-blue-700 dark:bg-sky-700': context.active
                    }
                  )
                }),
              },
              column: {
                headercell: ({ context, props }) => ({
                  className: classNames(
                    'text-left border-0 border-b border-solid border-gray-300 dark:border-blue-900/40 font-bold',
                    'transition duration-200',
                    context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
                    context.sorted ? 'bg-blue-50 text-blue-700' : 'bg-slate-50 text-slate-700', // Sort
                    context.sorted ? 'dark:text-white/80 dark:bg-blue-300' : 'dark:text-white/80 dark:bg-gray-900', // Dark Mode
                    {
                      'sticky z-[1]': props.frozen || props.frozen === '', // Frozen Columns
                      'border-x border-y': context?.showGridlines,
                      'overflow-hidden space-nowrap border-y relative bg-clip-padding': context.resizable // Resizable
                    }
                  )
                }),
                headercontent: 'flex items-center',
                bodycell: ({ props, context }) => ({
                  className: classNames(
                    'bg-card dark:bg-card_dark',
                    'text-left border-0 border-b border-solid border-gray-300',
                    context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
                    'dark:text-white/80 dark:border-blue-900/40', // Dark Mode
                    {
                      'sticky bg-inherit': props && (props.frozen || props.frozen === ''), // Frozen Columns
                      'border-x border-y': context.showGridlines
                    }
                  )
                }),
                footercell: ({ context }) => ({
                  className: classNames(
                    'text-left border-0 border-b border-solid border-gray-300 font-bold',
                    'bg-slate-50 text-slate-700',
                    'transition duration-200',
                    context?.size === 'small' ? 'p-2' : context?.size === 'large' ? 'p-5' : 'p-4', // Size
                    'dark:text-white/80 dark:bg-gray-900 dark:border-blue-900/40', // Dark Mode
                    {
                      'border-x border-y': context.showGridlines
                    }
                  )
                }),
                bodyrow: ({ context }) => ({
                  className: classNames(
                    context.selected ? 'bg-blue-50 text-blue-700 dark:bg-blue-300' : 'bg-white text-gray-600 dark:bg-gray-900',
                    context.stripedRows ? (context.index % 2 === 0 ? 'bg-white text-gray-600 dark:bg-gray-900' : 'bg-blue-50/50 text-gray-600 dark:bg-gray-950') : '',
                    'transition duration-200',
                    'focus:outline focus:outline-[0.15rem] focus:outline-blue-200 focus:outline-offset-[-0.15rem]', // Focus
                    'dark:text-white/80 dark:focus:outline dark:focus:outline-[0.15rem] dark:focus:outline-blue-300 dark:focus:outline-offset-[-0.15rem]', // Dark Mode
                    {
                      'cursor-pointer': context.selectable,
                      'hover:bg-gray-300/20 hover:text-gray-600': context.selectable && !context.selected // Hover
                    }
                  )
                }),
                rowexpansion: 'bg-white text-gray-600 dark:bg-blue-900 dark:text-white/80',
                rowgrouptoggler: {
                  className: classNames(
                    'text-left m-0 p-0 cursor-pointer select-none',
                    'inline-flex items-center justify-center overflow-hidden relative',
                    'w-8 h-8 text-gray-500 border-0 bg-transparent rounded-[50%]',
                    'transition duration-200',
                    'dark:text-white/70' // Dark Mode
                  )
                },
                rowgrouptogglericon: 'inline-block w-4 h-4',
                resizehelper: 'absolute hidden w-px z-10 bg-blue-500 dark:bg-blue-300',
              }
            }}
            onPage={onPage}
            emptyMessage="Nenhuma transação encontrada."
            loading={loading}
            header={transationTableHeader}>
            <Column
              field="valor"
              header="Valor"
              body={rowData => formatCurrency(Number(rowData.valor))}></Column>
            <Column
              field="data"
              header="Data"></Column>
            <Column
              headerStyle={{ width: '10rem', textAlign: 'center' }}
              bodyStyle={{ textAlign: 'center', overflow: 'visible', justifyContent: 'center' }}
              header="Detalhes"
              body={actionTemplate}></Column>
          </DataTable>
        </div>
      </div>
    </>
  )
}
